import { render, staticRenderFns } from "./Relatorio-smd.vue?vue&type=template&id=1c816aec&scoped=true&"
import script from "./Relatorio-smd.vue?vue&type=script&lang=js&"
export * from "./Relatorio-smd.vue?vue&type=script&lang=js&"
import style0 from "./Relatorio-smd.vue?vue&type=style&index=0&id=1c816aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c816aec",
  null
  
)

export default component.exports